import { Fragment } from "react"

export default function Nl2br({text}) {
    return (
        <>
            {text?.split('\n').map((item, key) => {
                return <Fragment key={key}>{item}<br/></Fragment>
            })}
        </>
    )
}